import React from "react";
import OutletContext from "./OutletContext.js";
import useOutletController from "./useOutlet.controller.js";
export default function OutletProvider(props) {
    const { children } = props;
    const value = useOutletController();
    return React.createElement(OutletContext.Provider, { value: value }, children);
}
